export default __webpack_public_path__ + "static/media/i-history.af40b6c8.svg";